import { usePageScrollRestoration } from "@vendistri/ui";
import { useLocation, useNavigationType } from "react-router-dom";

export function AppScrollRestoration() {
  const location = useLocation();
  const navigation = useNavigationType();
  usePageScrollRestoration({
    entryKey: `portal:${location.key}`, pathname: location.pathname,
    historyNavigation: navigation === "POP",
    delegated: /^\/growth\/marketplace(?:\/|$)/.test(location.pathname),
  });
  return null;
}
